// extracted by css-extract-rspack-plugin
export default {"HorizontalScrollBox":"EntityPicker-module__HorizontalScrollBox___JtYEG"};